import React from 'react';

import {SearchDatesInputField} from '../SearchDatesInputField';
import {SearchDestinationInputField} from '../SearchDestinationInputField';
import {SearchGuestsInputField} from '../SearchGuestsInputField';
import {SearchSubmitButtonField} from '../SearchSubmitButtonField';

import {useComponent} from './hooks';

import './SearchFields.less';

import '../SearchField/SearchField.less';
import '../SearchInputField/SearchInputField.less';
import '../SearchButtonField/SearchButtonField.less';

function SearchFields() {
    const {
        className,
        showDestinationInput,
        showDatesInput,
        showGuestsInput,
        showSubmitButton
    } = useComponent();

    return (
        <div className={className}>
            {showDestinationInput && (
                <SearchDestinationInputField/>
            )}
            {showDatesInput && (
                <SearchDatesInputField/>
            )}
            {showGuestsInput && (
                <SearchGuestsInputField/>
            )}
            {showSubmitButton && (
                <SearchSubmitButtonField/>
            )}
        </div>
    );
}

export {SearchFields};
